import React from "react";

const TermsAndConditions = () => {
  return (
    <div
      className="bg-white p-3 rounded mb-4"
      style={{ maxHeight: "150px", overflowY: "auto" }}
    >
      <p className="small">
        By purchasing this physical product from Tailored Stories, you agree to
        the following terms:
      </p>
      <p className="small fw-bold">Product Information:</p>
      <ol className="small pl-3">
        <li>
          All prints are for personal use only and may not be reproduced,
          distributed, or used for commercial purposes without our express
          written permission.
        </li>
        <li>
          We strive to provide accurate descriptions and images of our prints,
          but slight variations may occur due to screen settings and print
          processes.
        </li>
      </ol>
      <p className="small fw-bold">Shipping and Delivery:</p>
      <ol className="small pl-3">
        <li>
          Estimated delivery times are provided at checkout and are subject to
          change due to unforeseen circumstances.
        </li>
        <li>
          Customers are responsible for providing accurate shipping information.
          We are not liable for delays or issues caused by incorrect addresses.
        </li>
      </ol>
      <p className="small fw-bold">Returns and Refunds:</p>
      <ol className="small pl-3">
        <li>
          All physical products are non-refundable. We do not accept returns or
          offer refunds for any reason other than if the print is damaged or
          incorrect upon arrival.
        </li>
        <li>
          To report a damaged or incorrect print, please contact us at
          contact@tailoredstories.co.uk within fourteen days of delivery with
          your order number and a description of the issue.
        </li>
      </ol>
      <p className="small fw-bold">Intellectual Property:</p>
      <ol className="small pl-3">
        <li>
          All content on the website, including images, text, and logos, is
          owned by Tailored Stories and protected by intellectual property laws.
        </li>
        <li>
          You may not reproduce, distribute, or use any content without our
          express written permission.
        </li>
      </ol>
    </div>
  );
};

export default TermsAndConditions;
